export default __webpack_public_path__ + "static/h&sr-a710e40687af018e78dc765344425bbc.jpg";